const PRESELECT = location.hash.substr(1);
let formEventFired = false;

try {
    document.addEventListener('d365mkt-afterformload', function () {
        document
            .querySelectorAll('.marketingForm input[type="email"]')
            .forEach((emailField) => {
                const parentEl = emailField.parentElement;
                let emailInfoEl = null;

                if (parentEl) {
                    emailInfoEl = document.createElement('small');
                    emailInfoEl.innerHTML = `qq.com not supported`;
                    emailInfoEl.style.display = 'none';
                    parentEl.appendChild(emailInfoEl);
                }

                emailField.addEventListener('input', () => {
                    if (emailField.value.includes('@qq.com')) {
                        emailField.value = emailField.value.replace(
                            '@qq.com',
                            ' '
                        );
                        if (emailInfoEl) {
                            emailInfoEl.style.display = 'block';
                        }
                    } else {
                        if (emailInfoEl) {
                            emailInfoEl.style.display = 'none';
                        }
                    }
                });
            });

        if (!formEventFired) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'afterFormLoad',
            });
            formEventFired = true;
        }

        const forms = [...document.forms].filter((form) =>
            form.classList.contains('marketingForm')
        );

        if (forms && forms[0]) {
            const choice = forms[0];

            const personal = choice['go_choiceofappointment'][0];
            const video = choice['go_choiceofappointment'][1];
            const checkup = choice['go_choiceofappointment'][2];
            const locations = choice['go_desiredlocation'];
            const vienna = locations.querySelector("option[value='936520000']");

            if (locations && vienna) {
                if (checkup) {
                    checkup.addEventListener('change', (event) => {
                        if (checkup.checked) {
                            vienna.selected = true;
                            locations.disabled = true;
                        }
                    });
                }

                if (personal) {
                    personal.addEventListener('change', (event) => {
                        if (personal.checked) {
                            vienna.selected = false;
                            locations.disabled = false;
                        }
                    });
                }
                if (video) {
                    video.addEventListener('change', (event) => {
                        if (video.checked) {
                            vienna.selected = false;
                            locations.disabled = false;
                        }
                    });
                }
            }

            if (PRESELECT) {
                const values = PRESELECT.split('/');
                const contact = document.querySelector('.contact');
                const button = document.querySelector(
                    `.contact__choice[data-open="ms-dynamic-form__${values[0]}-form"]`
                );
                const type = values[1]
                    ? document.querySelector(
                          `input[name="go_choiceofappointment"][value="${mapPreselectType(
                              values[1]
                          )}"]`
                      )
                    : null;
                console.log({ values, type });
                if (button) {
                    activateMsDynamicsForm(button);
                }
                if (contact) {
                    window.Gator(window).on('load', () => {
                        contact.scrollIntoView();
                    });
                }
                if (type) {
                    type.click();
                }
            }
        }
    });
} catch (e) {
    console.error(e);
}

try {
    document.addEventListener('d365mkt-formsubmit', (event) =>
        submitTracking(event, 'formSubmittedBeforeUnload')
    );
    document.addEventListener('d365mkt-afterformsubmit', (event) =>
        submitTracking(event, 'formSubmitted')
    );
} catch (e) {
    console.error(e);
}

function submitTracking(event, eventId) {
    const closestForm = event.target.closest('.ms-dynamic-form');

    const dataLayerFormSubmitEvent = {
        event: eventId,
        formName: closestForm ? closestForm.dataset.form : 'undefined',
    };

    let promises = [];
    event.detail.payload.fields.forEach((field) => {
        if (field.key === 'go_choiceofappointment') {
            dataLayerFormSubmitEvent.formAppointment = mapChoiceOfAppointment(
                field.value
            );
        }
        if (field.key === 'go_interest') {
            dataLayerFormSubmitEvent.formInterest = mapInterest(field.value);
        }
        if (field.key === 'go_language') {
            dataLayerFormSubmitEvent.formLanguage = mapLanguage(field.value);
        }
        if (field.key === 'go_desiredlocation') {
            dataLayerFormSubmitEvent.formLocation = mapDesiredLocation(
                field.value
            );
        }
        if (field.key === 'new_salutation') {
            dataLayerFormSubmitEvent.formGender = mapSalutation(field.value);
        }

        if (field.key === 'firstname') {
            promises.push(
                hash(field.value).then((hash) => {
                    dataLayerFormSubmitEvent.formFirstname = hash;
                })
            );
        }
        if (field.key === 'lastname') {
            promises.push(
                hash(field.value).then((hash) => {
                    dataLayerFormSubmitEvent.formLastname = hash;
                })
            );
        }
        if (field.key === 'telephone1') {
            promises.push(
                hash(field.value.replace(/\D/g, '')).then((hash) => {
                    dataLayerFormSubmitEvent.formPhonenumber = hash;
                })
            );
        }
        if (field.key === 'emailaddress1') {
            promises.push(
                hash(field.value.toLowerCase()).then((hash) => {
                    dataLayerFormSubmitEvent.formEmail = hash;
                })
            );
        }

        if (closestForm) {
            const countrySelection = closestForm.querySelector(
                'input[name="ace_land"]'
            );
            if (countrySelection) {
                dataLayerFormSubmitEvent.formCountry = countrySelection.value;
            }
        }
    });

    Promise.allSettled(promises).then(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(dataLayerFormSubmitEvent);
    });
}

function activateMsDynamicsForm(button) {
    // choice
    const activatedChoice = document.querySelector(
        '.contact__choice.activated'
    );
    if (activatedChoice) {
        activatedChoice.classList.remove('activated');
    }
    button.classList.add('activated');

    // form
    const activatedForm = document.querySelector('.ms-dynamic-form.activated');
    if (activatedForm) {
        activatedForm.classList.remove('activated');
    }
    const formToActivate = document.querySelector(
        '.ms-dynamic-form.' + button.dataset.open
    );
    if (formToActivate) {
        formToActivate.classList.add('activated');
    }
}

function hash(string) {
    const utf8 = new TextEncoder().encode(string);
    return crypto.subtle.digest('SHA-256', utf8).then((hashBuffer) => {
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray
            .map((bytes) => bytes.toString(16).padStart(2, '0'))
            .join('');
        return hashHex;
    });
}

function mapPreselectType(value) {
    switch (value) {
        case 'consultationPersonal':
            return '936520000';
        case 'consultationVideo':
            return '936520001';
        case 'control':
            return '936520002';
        default:
            return value;
    }
}

function mapChoiceOfAppointment(value) {
    switch (value) {
        case '936520000':
            return 'personal_consultation';
        case '936520001':
            return 'online_consultation';
        case '936520002':
            return 'check_up';
        default:
            return 'undefined';
    }
}

function mapInterest(value) {
    switch (value) {
        case '936520000':
            return 'hair_transplant';
        case '936520001':
            return 'hair_loss_prevention';
        case '936520002':
            return 'micro_pigmentation';
        default:
            return 'undefined';
    }
}

function mapLanguage(value) {
    switch (value) {
        case '936520000':
            return 'de';
        case '936520001':
            return 'en';
        case '936520002':
            return 'it';
        default:
            return 'undefined';
    }
}

function mapDesiredLocation(value) {
    switch (value) {
        case '936520000':
            return 'Wien';
        case '936520001':
            return 'Linz';
        case '936520002':
            return 'Salzburg';
        case '936520003':
            return 'Innsbruck';
        case '936520004':
            return 'Dornbirn';
        case '936520005':
            return 'Graz';
        case '936520006':
            return 'Klagenfurt';
        case '936520007':
            return 'Augsburg';
        default:
            return 'undefined';
    }
}

function mapSalutation(value) {
    switch (value) {
        case '1':
            return 'm';
        case '2':
            return 'f';
        case '3':
            return 'd';
        default:
            return 'undefined';
    }
}
